import * as BABYLON from '@babylonjs/core';
import '@babylonjs/core/Debug/debugLayer';
import '@babylonjs/inspector';
import '@babylonjs/loaders';
import Models from './Models';
import ModelFile from './ModelFile';
import BabylonModel from './BabylonModel';
import ParameterErrors from '../errors/ParameterErrors';
import UrlHelper from '../core/UrlHelper';
import AssetsManager from '../assets_management/AssetsManager';
import Location from '../modelling/Location';
import '@babylonjs/loaders'
import BabylonModelsManagerCache from './BabylonModelsManagerCache';
import BabylonMeshesCombiner from './BabylonMeshesCombiner';
const { throwNotProvided, throwNotOfType } = ParameterErrors;
BABYLON.SceneLoader.loggingLevel = BABYLON.SceneLoader.DETAILED_LOGGING;
const PROPORTION_PROGRESS_DOWNLOADING_FILE=0.8;
export default class BabylonModelsManager {
    constructor(props) { 
        const { models, babylonMaterialsManager, babylonScene, modelsRootUrl} = props;
        if (!models) throwNotProvided("models");
        if (!models instanceof Models) throwNotOfType("models", Models.constructor.name);
        this._models = models;	
		if(!babylonScene)throwNotProvided('babylonScene');
		this._babylonScene = babylonScene;
		if(!modelsRootUrl)throwNotProvided('modelsRootUrl');
		this._modelsRootUrl=UrlHelper.makeSureSlashOnEnd(modelsRootUrl);
		this._babylonModelsManagerCache = new BabylonModelsManagerCache();
		this._babylonMeshesCombiner = new BabylonMeshesCombiner({scene:babylonScene });
		this._babylonMaterialsManager=babylonMaterialsManager;
		this._getModelFileFromModelAndOrCode = this._getModelFileFromModelAndOrCode.bind(this);
		this._scheduleApplyTexturesToModel = this._scheduleApplyTexturesToModel.bind(this);
		this._scheduleApplyTextureToMesh = this._scheduleApplyTextureToMesh.bind(this);
		this._makeBabylonMeshInvisible= this._makeBabylonMeshInvisible.bind(this);
		this._isCollider = this._isCollider.bind(this);
		this.getNewMesh = this.getNewMesh.bind(this);
		this.loadBabylonModel = this.loadBabylonModel.bind(this);
		
    }
	getNewMesh({code, location, objectIdNodeIdsMappings, loadBabylonModel, quadrantsPath, standardProgressSource}){
		const self = this;
		return new Promise((resolve, reject)=>{
			if(!location)location = Location.getDefault();
			const model = this._models.getModelByCode(code);
			if(!model)throw new Error(`Model with code ${code} doesnt exist in models json file`);
			const modelFile = this._getModelFileFromModelAndOrCode(model, code);
			if(!self._babylonModelsManagerCache.has(modelFile.fileName)){
				self.loadBabylonModel({code, location, modelFile, model, objectIdNodeIdsMappings, quadrantsPath, standardProgressSource})
				.then(babylonModel=>{
					if(standardProgressSource)standardProgressSource.progressProportion=1;
					resolve(babylonModel);
				}).catch(reject);
				return;
			}
			throw new Error('should not be here atm');
			const existingBabylonModel = self._babylonModelsManagerCache.get(modelFile.fileName);
			const babylonModel = existingBabylonModel.clone();
			babylonModel.setLocation(location);
			resolve(babylonModel);
		});
	}
	loadBabylonModel({code, location, modelFile, model, objectIdNodeIdsMappings, quadrantsPath, standardProgressSource}){
		const self = this;
		return new Promise((resolve, reject)=>{
			//const root = new BABYLON.TransformNode();
			const promiseGetQuadrants = AssetsManager.getQuadrants(quadrantsPath);
			BABYLON.SceneLoader.ImportMesh(null, modelFile.rootUrl, modelFile.fileName, this._babylonScene.scene,
				(babylonMeshes, particleSystems, skeletons)=>{
					try{
						/*babylonMeshes.forEach(babylonMesh => {
							if (babylonMesh.parent)return;
							babylonMesh.parent = root;
						});
						*/
						//self._applyTextures(model, this._babylonMaterialsManager, babylonMeshes).then(()=>{
						promiseGetQuadrants.then((quadrants)=>{
							const babylonModel = new BabylonModel({root:null, babylonMeshes, particleSystems,
							skeletons, code, location, quadrants, objectIdNodeIdsMappings});
							console.log(this._babylonScene);
							this._babylonScene.babylonModelAdded(babylonModel);
							console.log('did quadrants promise');
							console.log(quadrants);
							self._babylonModelsManagerCache.add(modelFile.fileName, babylonModel);
							if(standardProgressSource)standardProgressSource.progressProportion=1;
							resolve(babylonModel);
						}).catch(reject);
						//}).catch(reject);
					}
					catch(err){
						reject(err);
					}
				},
				(progress)=>{
					if(!standardProgressSource)return;
					const progressProportion = progress.loaded*PROPORTION_PROGRESS_DOWNLOADING_FILE/progress.total;
					standardProgressSource.progressProportion= progressProportion;
				},
				(scene, message)=>{
					reject(new Error(message));
				}
			);
		});
	}
	_combineMeshesByMaterial(){

	}
    _applyTextures(model, materialsManager, babylonMeshes) {
        return new Promise((resolve, reject) => { 
            this._scheduleApplyTexturesToModel(model, babylonMeshes, materialsManager);
            resolve();
        });
    }
    _scheduleApplyTexturesToModel(model, babylonMeshes, materialsManager) {
        const meshes = model.meshes;
        for (var index = 0; index < babylonMeshes.length; index++) {
            const babylonMesh = babylonMeshes[index];
            if (this._isCollider(babylonMesh)) {
				this._makeBabylonMeshInvisible(babylonMesh, materialsManager);
				continue;
            }
			const mesh = meshes.getByName(babylonMesh.name);
			let materialName;
			const hasMesh = mesh!==undefined&&mesh!==null;
			if(hasMesh){
				materialName = mesh.material;
			}
			else{
				if(babylonMesh.material===null)continue;
				materialName = babylonMesh.material.name;
			}
			this._scheduleApplyTextureToMesh(materialName, babylonMesh, materialsManager);
        }
    }
    _makeBabylonMeshInvisible(babylonMesh, materialsManager) {
        babylonMesh.material = materialsManager.getInvisibleMaterial();
    }
    _scheduleApplyTextureToMesh(materialName, babylonMesh, materialsManager) {
        materialsManager.getBabylonMaterialByName(materialName).then((babylonMaterial) => {
            babylonMesh.material = babylonMaterial;
        }).catch(console.error);
    }
	_getModelFileFromModelAndOrCode(model, code){
		const modelRelativePath = model.relativePath;
		if(modelRelativePath){
			const suffix = UrlHelper.removeStartSlash(modelRelativePath);
			const url = `${this._modelsRootUrl}${suffix}`;
			return new ModelFile({code:code, url:url}); 
		}
		return new ModelFile({code:code, rootUrl:this._modelsRootUrl,  fileName:`${code}.gbx`}); 
	}
    _isCollider(babylonMesh) {
        const name = babylonMesh.name;
        return name === 'Collider' || name === 'collider';
    }
}